import {AfterViewChecked, AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {animateShow} from '@src/app/animations/showHideAnimation';
import {Item} from '@src/app/models/Item';
import {isPresetEnabled} from '@src/configs/globalVariables';

interface SetUp {
  name: string,
  id: number
}

@Component({
  selector: 'app-preset',
  templateUrl: './preset.component.html',
  styleUrls: ['./preset.component.scss'],
  animations: [animateShow],
})
export class PresetComponent implements OnChanges, AfterViewInit {

  @ViewChild('scrollbar', {static: false}) scrollbar;
  @Input() item: Item;
  public Yiit = Yiit;

  constructor() {
  }

  ngOnChanges() {
    if (this.isContainSetUpList() && !this.getSelectedSetUpId()) {
      this.setSelectedSetUp(this.setUpList[0]);
    }
    if (this.isContainSetUpList() && this.scrollbar && !Scrollbar.has(this.scrollbar.nativeElement)) {
      Scrollbar.init(this.scrollbar.nativeElement);
    }
  }

  ngAfterViewInit() {
    if (this.isContainSetUpList()) {
      Scrollbar.init(this.scrollbar.nativeElement);
    }
  }


  isPresetActive() {
    return this.item.config.isContainPreset && isPresetEnabled;
  }

  isSetUpActive() {
    return this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'active');
  }

  getSelectedSetUpId() {
    return this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'selected');
  }

  changeSetUpActive() {
    const val = this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'active');
    this.item.config.setInputValue(Item.SET_UP_AREA_INPUT, 'active', !val);
  }

  isContainSetUpList() {
    let val = this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'value');
    return val && val.length > 0;
  }

  get setUpList(): SetUp[] {
    return this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'value');
  }

  createSetUp() {
    let currentVal = this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'value');
    if (!currentVal) {
      currentVal = [];
    }
    let setUpId = this.getIndexOfCreatedSetUp(currentVal);
    let setUpName = currentVal.length + 1;
    let newSetUp: SetUp = {
      id: setUpId,
      name: 'Set-up ' + setUpName,
    };
    let confirmRes = false;
    if (currentVal.length === 0){
      confirmRes = confirm(Yiit.t('All objects placed within the polygon will be added to this set-up'));
    } else {
      confirmRes = true;
    }
    if (confirmRes) {
      currentVal.push(newSetUp);
      this.item.config.setInputValue(Item.SET_UP_AREA_INPUT, 'value', currentVal);
      if (currentVal.length === 1) {
        this.item.config.setInputValue(Item.SET_UP_AREA_INPUT, 'selected', newSetUp.id);
        if (this.scrollbar && !Scrollbar.has(this.scrollbar.nativeElement)) {
          Scrollbar.init(this.scrollbar.nativeElement);
        }
      }
    }
  }

  setSelectedSetUp(setup: SetUp) {
    this.item.config.setInputValue(Item.SET_UP_AREA_INPUT, 'selected', (setup) ? setup.id : null);
    this.item.getObservable('selectedSetUpChanged').next((setup) ? setup.id : null);
  }

  isSetUpSelected(setup: SetUp) {
    return this.item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'selected') == setup.id;
  }

  editSetUpName($event: MouseEvent, setup: SetUp) {
    $event.preventDefault();
    const inputElm: HTMLInputElement = document.querySelector('.set-up-input-' + setup.id);
    const endIndex = inputElm.value.length;
    inputElm.readOnly = false;
    inputElm.setSelectionRange(endIndex, endIndex);
    inputElm.focus();
  }

  setReadOnly(setup: SetUp, flag: boolean) {
    const inputElm: HTMLInputElement = document.querySelector('.set-up-input-' + setup.id);
    inputElm.readOnly = flag;
  }

  changeSetUpName($event, setup: SetUp) {
    let val = $event.target.value;
    let index = this.getSetUpIndex(setup.id);
    if (index === null) {
      return;
    }
    let list = this.setUpList;
    if (list[index].name !== val) {
      list[index].name = val;
      this.updateSetUpList(list);
    }
  }

  removeSetup($event, setup: SetUp) {
    $event.preventDefault();
    if (!confirm(Yiit.t('By deleting the set-up, all the objects within this set-up will be deleted. This action cannot be undone.'))) {
      return;
    }
    let index = this.getSetUpIndex(setup.id);
    if (index === null) {
      return;
    }
    let selectedSetUpId = this.getSelectedSetUpId();

    let list = this.setUpList;
    list.splice(index, 1);
    this.updateSetUpList(list);
    if (selectedSetUpId == setup.id) {
      if (this.isContainSetUpList()) {
        this.item.getObservable('removeSetUp').next({removedSetUpId: setup.id, newSetUpId: this.setUpList[0].id});
        return this.setSelectedSetUp(this.setUpList[0]);
      }
      this.item.getObservable('removeSetUp').next({removedSetUpId: setup.id, newSetUpId: null});
      this.setSelectedSetUp(null);
    }
  }

  private updateSetUpList(list) {
    console.log('updateSetUpList', list.slice());
    this.item.config.setInputValue(Item.SET_UP_AREA_INPUT, 'value', list);
  }

  private getSetUpIndex(id: number) {
    let list = this.setUpList;
    for (let i = 0; i < list.length; i++) {
      if (list[i].id == id) {
        return i;
      }
    }
    return null;
  }

  private getIndexOfCreatedSetUp(currentVal: SetUp[], index?): number {
    let _index = (index != undefined) ? index + 1 : currentVal.length + 1;
    if (currentVal.some(setup => setup.id == _index)) {
      return this.getIndexOfCreatedSetUp(currentVal, _index);
    }
    return _index;
  }
}
